<template>
  <div style="width:100%;">
    <div style="padding: 16px 20% 16px 20%;">
      <h2>关于我们</h2>
      <p>
        “海阔凭鱼跃，天高任鸟飞”。在深圳风云激荡、潮起潮落的改革开放洪流中，海雅集团展现出民营企业勃勃生机，彰显出民族资本旺盛活力，磨砺成为杰出的行业经营者，历练成为智慧的产业投资人，发展壮大成为市场的领航人、时代的佼佼者。
      </p>
      <p>
        “海涵万象，雅韵天成”。海雅集团锐意进取、奋发图强，取得了一个又一个辉煌业绩，谱写出新时代民营企业的生动传奇。
      </p>
      <p>
        海雅集团现已发展成为集大型商业地产，城市综合体开发与经营，精品连锁商业，文化生态旅游产业、休闲康养小镇规划与建设，互联网与新经济产业园，金融与证券投资，酒店与物业管理等多元化发展于一体的大型现代企业集团。资产规模同行业名列前茅，下属成员企业42家，员工总数超过3.8万人。
      </p>
      <p>
        掌舵人涂辉龙先生，是第十一届、第十二届、第十三届、第十四届全国政协委员，是第八届、第九届、第十届广东省政协委员、常委，是香港各界文化促进会主席，香港太平绅士，中国同胞海外救助基金理事会理事长、中国企业联合会副会长，是第八届、第九届、第十届广东省工商联（总商会）副主席、副会长，是第二届、第三届广东省投资商会会长，港区省政协委员联谊会会员事务委员会主任，香港广东社团首席会长，香港中文大学（深圳）校董会成员，香港义工联盟常务副主席，海雅集团董事局主席，香港海雅投资有限公司董事局主席。
      </p>

      <h3>核心产业</h3>

      <h4>一、大型商业地产，城市综合体开发、建设与经营</h4>
      <p>集团把握城市发展脉搏，引导城市转型升级，打造大型商业地产、城市综合体开发、建设与经营。</p>
      <h5>海雅缤纷城商业中心</h5>
      <p>
        雄踞粤港澳大湾区深圳前海中心的海雅缤纷城商业中心，是深圳市超大规模的现代化商业综合体，总建筑面积32万平方米，投资总额86亿。
      </p>
      <p>
        涂辉龙先生率先将文化、艺术、培训等融入购物中心，全资经营海雅文化传播公司，实现了购物中心业态新时代的创新与繁荣。最潮流的商业设计、最丰富的业态配置、最时尚的品牌组合、最优秀的经营团队、最完善的物业管理，成就了深圳最大人流量购物中心的诞生，被誉为深圳国际时尚品牌聚集地，都市生活新的闪亮名片。
      </p>
      <h5>海雅昆明翠谷国际中心</h5>
      <p>
        位于昆明市繁华中心区，是地铁1号线、2号线交汇点上盖大型城市综合体项目，总建筑面积21万平方米。是云南省和昆明市重点建设项目，将打造新经济总部基地和昆明海雅东盟国际中心，成为昆明市城市新坐标。
      </p>
      <p>  
        集团还参与深圳多个城市更新项目，继续扩大在深圳的投资。南山海雅缤纷广场已获批更新改造，总投资超过50亿元，兴建“深圳海雅国际中心”。
      </p>

      <h4>二、精品连锁商业</h4>
      <p>
        遍布粤港澳大湾区核心城市，引导多个城市商圈的形成和繁荣。历年被评为当地“十大最具公信度商场”、“纳税百强企业”、“纳税大户企业”、“重合同守信用企业”、“劳动关系和谐企业”、“卓越商业品牌大奖”、“深圳老字号”等。
      </p>

      <h4>三、文化生态旅游产业，休闲康养小镇规划与建设</h4>
      <h5>海雅柳江湾国际文化生态旅游港</h5>
      <p>
        项目位于柳州市鱼峰碧芙蓉片区，总占地6000亩，总建筑面积230万平方米，包括大型生态园林住宅、文化旅游商业综合体、五星级酒店、高尔夫体育公园等。
      </p>
      <p>
        “海雅柳江湾国际文化生态旅游港”以柳江湾自然风景为生态环境，以石质木质野奢建筑群为设计风格，以小桥流水曲径通幽为园林特色，以高科技、快时尚、慢生活为经营内容，打造的大型开放式文化旅游商业综合体。
      </p>
      <p>  
        有奇石科技文化、白莲螺丝文化、农耕部落文化、蛙神岩画文化、柳江人文化五大主题区，以及设置风格迥异的湖畔民宿、森林酒店、野奢酒店、猴神亲子酒店。
      </p>
      <p>
        项目可直接提供就业岗位约1万个，每年吸引游客数量超600万人。
      </p>
      <p>
        千亩大城，百万平方米海雅•柳江湾生态园林住宅已拔地而起。
      </p>

      <h4>四、互联网与新经济产业园</h4>
      <h5>海雅国际创客商业中心</h5>
      <p>
        已被列入广东省三旧改造重点项目、中山市重大服务产业和重点工程建设项目。项目总占地352亩，总建筑面积128万平方米，投资总额超110亿。
      </p>
      <p>
        项目一期住宅及公寓已顺利竣工，并实现火爆销售，成为中山市城市发展新的形象和投资市场新的风向标。
      </p>
      <p>
        项目二期58万平方米大型新零售业态购物中心和海雅喜来登五星级酒店大规模城市综合体已完成主力店招商签约，是中山市加快推进粤港澳大湾区战略实施的新亮点，将成为中山市融入粤港澳大湾区总体发展战略的桥头堡和制高点。
      </p>
      <h5>海雅粤港澳国际中心</h5>
      <p>
        项目位于中山市翠亨新区，毗邻深中通道，项目总占地52.7亩，总建筑面积约31万平方米，投资总额超25亿。涵盖投资接待中心、国际创客孵化区、创业成果展示区、教育培训中心、“一带一路”投资论坛及会议中心等功能。以“互联网+智能制造”为科技创新手段，以“生物医药”、“大健康”为产业方向。全面增强中山经济整体科技水平和自主创新能力，带动粤港澳高科技人才创业、就业、安居乐业，实现科技成果孵化、转化和国际技术转移，为创新成果产业化发展提供现代服务业平台和配套。
      </p>
      <p>
        首批全国布局的“海雅国际中心”还包括深圳海雅国际中心、昆明海雅东盟国际中心、海雅华南国际中心。每个中心年接待百万华侨华人，可举办数百场各类主题活动、论坛、会议和展览。
      </p>

      <h4>五、金融与证券投资</h4>
      <p>
        集团凭借雄厚的资本实力，参股投资银行、证券等金融企业，选择发展前景和成长性良好的优质企业，进行战略性风险投资，为企业未来的发展占领制高点打下牢固基础，也为培育集团“创二代”企业家创造良好的投资条件。
      </p>

      <h3>社会责任</h3>
      <p>
        海雅集团的发展、成熟、壮大，离不开党和政府、社会各界合作伙伴的大力支持，多位国家领导亲切接见集团董事局主席涂辉龙先生。
      </p>
      <p>
        海雅集团始终秉持“德行天下，回馈社会”的宗旨，几十年如一日坚持不懈做慈善。20多年来，涂辉龙先生以企业和个人名义向社会公益慈善事业、救灾救济等捐献款物超过6.3亿元，捐建多所希望小学、医院、敬老院，组织、倡导、募集教育基金1亿6千多万元，支持公路和大桥建设等。
      </p>
      <p>
        2016年为国家发展数字侨联捐资1.2亿元，2018年捐资1亿元，设立香港中文大学（深圳）“涂辉龙创新教育基金”，鼓励支持港中大（深圳）发展学术工作，资助贫困学生，奖励优秀教师。2019年为香港爱国爱港社团、慈善互助基金等捐资超过7000万元。
      </p>
      <p>
        涂辉龙先生多次荣获国家、省、市“光彩事业杰出贡献奖”、“振兴教育事业贡献奖”、“南粤好乡贤”、“杰出企业社会责任奖”等荣誉称号。
      </p>
      <p>
        2021年，涂辉龙作为香港各界文化促进会主席，组织举办“中国共产党成立百年庆典暨香港各界文化促进会成立20周年大型音乐会”。
      </p>

      <h3>昭续家风</h3>
      <p>
        “义方既训，家道颖颖。岂敢荒宁，一日三省。”涂辉龙先生的儿女都出类拔萃。
      </p>
      <p>
        涂尔帆，集团董事、执行总裁。毕业于英国剑桥大学，现任深圳市政协委员、深圳市工商联总商会副会长。
      </p>
      <p>
        涂尔鹏，集团董事，执行总裁。毕业于英国伦敦大学，现任广东省政协委员。
      </p>
      <p>
        涂雪明，集团副总裁。毕业于英国帝国理工大学，现任宝安区女企业家协会副会长。
      </p>
      <p>
        “宝剑锋从磨砺出，梅花香自苦寒来”。涂尔帆负责集团商业系统和金融投资工作，已积累了十多年丰富经验，持之以恒促招商，精益求精抓管理，推动了集团商业事业的不断进步，现正带领集团商业大力推动体制改革，建立楼层独立经营核算机制，打造海雅“超级经理人”，为集团商业持续发展注入新的动能；涂尔鹏负责集团地产板块、城市综合体开发工作，同样展示出杰出的才能，知人善任谋大局，沉着冷静求发展，现正带领集团地产加快开发城市综合体和文旅小镇项目建设，为集团地产创造辉煌增添新的贡献。
      </p>
      <p>
        “兄弟齐心，其利断金”。涂尔帆、涂尔鹏联手参与土地竞价，成功摘牌；联手打造城市综合体和文旅小镇，成为涂辉龙先生得力的左膀右臂。
      </p>

      <h3>企业文化</h3>
      <p>
        企业文化是企业的灵魂，优秀的企业文化是企业长盛不衰的不竭动力。海雅集团始终坚持“以人为本”的发展观不动摇，海雅集团广揽贤才、广举贤才。一大批社会精英，青年才俊聚集在集团发展的洪流中，成为推动事业不断创新、不断超越、不断前进的强大力量。在积极引入人才的同时，不断提高全体员工素质，充分发挥员工的主动性和创造性，展示了中国现代企业所具有的特殊魅力，奏响了当今企业文化建设的最强音。
      </p>
      <p>
        企业宗旨：追求进步，丰富生活，争创中国最一流企业。
      </p>
      <p>
        经营思想：商品潮流化，服务人性化，管理科学化。
      </p>

      <h3>发展远景</h3>
      <p>
        “争创新优势，更上一层楼”。海雅集团正积极投身民族复兴的宏伟实践，助力祖国，走向世界，走向繁荣。产业发展的设计方案、经营理念和发展模式，受到普遍高度重视，成为各地竞相招商引资的重点，全国政协经济委刘世锦、肖钢、姜洋及有关国家部委、省、市领导多次莅临考察。
      </p>
      <p>
        “潮平两岸阔，风正一帆悬”。海雅集团正在续写民营企业奋发图强新的篇章，正在铸就民族资本繁荣兴旺新的辉煌，奋力实现“创海雅百年基业，塑全国一流企业”的宏伟目标。
      </p>
    </div>  
  </div>
</template>
<script>

export default {
  name: "newsText"
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";

/deep/ h2{
  color: #1890FF;
  font-size: 32px;
  text-align: center;
  margin: 0px;
}

/deep/ h3{
  color: #1890FF;
  font-size: 24px;
}

/deep/ h4{
  color: #1890FF;
  font-size: 18px;
}

/deep/ h5{
  color: #000000;
  font-size: 16px;
  margin-bottom: 8px;
}

/deep/ p{
  color: #000000 ;
  font-size: 16px;
  text-indent: 2em;
}
</style>